"use client";
import { SectionPromo } from "@/components/pages/samples/SectionPromo";
import { StandardSectionCTA } from "@/components/shared/sections/StandardSectionCTA";
import { SectionFiltersProps, usePageFilters } from "@/utils/usePageFIlters";
import { SampleFilterContext } from "@/components/SampleFilterContext";
import { SectionFilters } from "@/components/pages/category/SectionFilters";
import { useEffect, useRef, useState } from "react";
import { animateScroll } from "@/utils/animateScroll";
import { useAppSelector } from "@/store";
import { isRedirectionSelector } from "@/store/global/globalSlice";

export type SamplesPageProps = {
  filters: SectionFiltersProps;
};

export const SamplesPage = ({ filters }: SamplesPageProps) => {
  const contextValue = usePageFilters(filters);
  const isRedirecting = useAppSelector(isRedirectionSelector);

  const currentTitle = contextValue.selectedValues.title;

  const [isFirstView, setFirstView] = useState(true);
  const [prevTitle, setPrevTitle] = useState(currentTitle);

  const firstViewRef = useRef(isFirstView);
  firstViewRef.current = isFirstView;

  useEffect(() => {
    const container = document.getElementById("section-sample-filters");
    if (!container) return;

    let animateCondition = false;

    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    // animate to results on first page view
    if (firstViewRef.current && currentTitle) {
      animateCondition = true;
      // animate to results only if search term changed
    } else if (!firstViewRef.current && !isRedirecting && currentTitle !== prevTitle) {
      setPrevTitle(currentTitle);
      animateCondition = true;

      // animate to results only if screen is lower
    } else if (!firstViewRef.current && !isRedirecting) {
      animateCondition = isMobile || container.getBoundingClientRect().top < -20;
    }

    if (animateCondition) {
      const offset = isMobile ? 40 : 90;
      animateScroll(container, offset);
    }

    setFirstView(false);
  }, [isRedirecting, currentTitle, prevTitle]);

  return (
    <SampleFilterContext.Provider value={contextValue}>
      <SectionPromo />
      <SectionFilters showTotal />
      <StandardSectionCTA />
    </SampleFilterContext.Provider>
  );
};
